import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class OverflowDetectorService {
  public isOverflowing(element: HTMLElement): boolean {
    return (
      element.scrollWidth > element.offsetWidth ||
      element.scrollHeight > element.offsetHeight
    );
  }
}
